import React from 'react'
import type { PublicVideoRequest } from 'apollo-gql'
import { useTranslation } from 'lib/i18n'
import { isMobile } from 'react-device-detect'

import SharingButtons from 'components/SharingButtons/SharingButtons'
import Typography from 'components/UI/Typography/Typography'
import useLanguage from 'hooks/useLanguage'
import useMarket from 'hooks/useMarket'

import styles from './VideoShare.module.css'

type VideoShareProps = {
  request: PublicVideoRequest
  className?: string
  hideSocialMediaLinks?: boolean
}

const VideoShare = ({
  request,
  className,
  hideSocialMediaLinks = false,
}: VideoShareProps): JSX.Element => {
  const { t } = useTranslation()
  const market = useMarket()
  const language = useLanguage()

  const relativeUrl = `/${market.id}/${language.code}/video/${request.shortId}`

  const { toName, publicProfile: profile, video } = request

  const shareText = t('VideoRequestPage.heading1', 'Send or share your video!')

  const HeadingTypography = isMobile ? Typography.H6 : Typography.BodyBold

  const download = {
    url: video?.available && video?.downloadUrl,
    from: profile.name,
    to: toName,
  }

  return (
    <div className={className}>
      <HeadingTypography className={styles.shareHeading}>
        <h2>{shareText}</h2>
      </HeadingTypography>

      <SharingButtons
        request={request}
        relativeUrl={relativeUrl}
        talentSlug={profile.slug}
        download={download}
        showIcons
        hideSocialMediaLinks={hideSocialMediaLinks}
      />
    </div>
  )
}

export default VideoShare
